const validateAnswer = function (errors, vm, showTip) {
  const descList = this.descList
  const { answerConfig: { requireInd } } = this
  if (!descList.length) {
    return false
  }
  if (requireInd === '1') {
    if (this.descList.some(item => !item.value.trim().length)) {
      errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
    }
    return !errors.length
  }
  return !errors.length
}

const validate = function (vm, showTip) {
  const errors = []
  return {
    result: validateAnswer.call(this, errors, vm, showTip),
    errors
  }
}

const answerValidate = {
  validateAnswer,
  validate
}

export default answerValidate



// WEBPACK FOOTER //
// ./src/components/editor/FillBlankBox/answerValidate.js